/**
  * Login page
  * ==========
  *
  */

// Services
import AuthenticationService from '@/services/AuthenticationService';
import ResetPasswordService from '@/services/ResetPasswordService';

// Event Bus
import { EventBus } from '@/EventBus.js';

export default {

  name: 'login',

  components: {

  },

  data: function() {
    return {
      mode: 'login',

      // Login Mode
      email: null,
      password: null,
      loginActive: false,

      // Reset Password Mode
      emailReset: null,
      passwordResetSent: false
    }
  },

  mounted: function() {
    this.$refs.inputEmail.focus();
  },

  methods: {

    /**
      * Log the user in
      */
    doLogin:function(){
      // Currently processing login (used to display the loading animation)
      this.loginActive = true;
      // Authenticate
      AuthenticationService.authenticate(this.email, this.password)
        .then((res) => {
          if (res && res.status == 200) {
            // Login was successful
            localStorage.setItem('accessToken', res.data.token);
            localStorage.setItem('userId', res.data.user.userId);
            localStorage.setItem('userGroup', res.data.user.group);
            localStorage.setItem('userObject', JSON.stringify(res.data.user));

            let route = null;
            let id = null;

            switch (res.data.user.group) {
              case 'retailers':
                // route = 'retailers';
                route = 'dashboard';
                id = res.data.user.retailer;
                break;

              case 'multi-site-retailers':
                // route = 'retailers-multi';
                // id = res.data.user.multiSite;
                route = 'dashboard';
                id = res.data.user.multiSite;
                break;

              case 'service-providers':
                route = 'dashboard';
                id = res.data.user.serviceProvider;
                break;

              case 'hsg-admins':
                route = 'dashboard';
                break;

              default:

                break;
            }

            if(id) {
              if(route != 'dashboard') {
                route = route + '/' + id;
              }

              localStorage.setItem('parentId', id);
            }

            localStorage.setItem('homeRoute', route);

            if(res.data.user.group) {
              // if we have a referrer url go there
              if(this.$route.query.referrerurl) {
                let url = decodeURIComponent(this.$route.query.referrerurl);
                if(url && url.length > 0) {
                  this.$router.push(url);
                }
                else {
                  this.$router.push(route);
                }

              }
              else {
                this.$router.push(route);
              }
            }
            else {
              EventBus.dispatchErrorEvent('Whoops! This login is not part of any groups, please contact support.' );
            }
          }
          else {
            // Something went wrong
            EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.status == 404) {
            // Incorrect credentials
            EventBus.dispatchErrorEvent('The username or password was incorrect');
          }
          else {
            // Something went wrong
            EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
          }

          this.loginActive = false;
        });
    },

    doResetPassword: function() {
      if(this.emailReset && this.emailReset.trim() != '') {
        ResetPasswordService.resetPassword(this.emailReset)
          .then((res) => {
            this.passwordResetSent = true;
          })
          .catch((err) => {
            if(err.response.status && err.response.status == 404) {
              EventBus.dispatchErrorEvent('The email address provided was not found');
            }
            else {
              EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
            }
          });
      }
      else {
        EventBus.dispatchErrorEvent('You must provide an email address');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Login/Login.js